import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Divider,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import { Icon } from '@iconify/react/dist/iconify.js';
import GoalForm from './Goalform';
import BulkUploadForm from './BulkUploadForm';
import { useLocation, useNavigate } from 'react-router-dom';
import { getAllQuarters } from '../../../redux/features/appraisalSlice';

const AddGoals = () => {
  const dispatch = useDispatch();
  const { loading, tagNames } = useSelector((state) => state.appraisal);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const location = useLocation();

  const { goal, newJobFieldRequired } = location.state || {};
  const user = location?.state?.user;
  const adminView = location?.state?.adminView;
  const [activeTab, setActiveTab] = useState('goal');
  const [viewTags, setviewTags] = useState(false);
  const navigate = useNavigate();

  const profile = JSON.parse(localStorage.getItem('cred')).profile;

  const downloadSampleExcel = () => {
    const link = document.createElement('a');
    link.href = '/sheets/SampleSheetGoal.xlsx';
    link.download = 'SampleSheetGoal.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadSampleExcelUser = () => {
    const link = document.createElement('a');
    link.href = '/sheets/SampleSheetGoalUser.xlsx';
    link.download = 'SampleSheetGoalUser.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const data = {
    search: null,
    page: 1,
    limit: 20,
  };

  useEffect(() => {
    dispatch(getAllQuarters(data));
  }, []);

  return (
    <GlobalWrapper title={'Add Goal'}>
      <Box sx={{ width: '100%', padding: 0 }}>
        {/* Top Navigation Buttons */}
        <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
          <Button
            onClick={() => navigate('/Appraisal-Management/goal')}
            color="primary"
            variant="contained"
            size="small"
            startIcon={<Icon icon="lets-icons:back" width="20" height="20" />}
          >
            Back
          </Button>
          <Button
            onClick={() => setActiveTab('goal')}
            color="secondary"
            size="small"
            variant={activeTab === 'goal' ? 'contained' : 'outlined'}
            startIcon={<Icon icon="ei:plus" width="20" height="20" />}
          >
            Add Goals
          </Button>
          <Button
            onClick={() => setActiveTab('bulk')}
            color="secondary"
            size="small"
            variant={activeTab === 'bulk' ? 'contained' : 'outlined'}
            startIcon={<Icon icon="mdi:upload" width="20" height="20" />}
          >
            Bulk Upload
          </Button>
        </Stack>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={8}>
            {/* Add Goal Form */}
            {activeTab === 'goal' && (
              <GoalForm
                goals={goal}
                user={user}
                adminView={adminView}
                newJobFieldRequired={newJobFieldRequired}
              />
            )}

            {activeTab === 'bulk' && (
              <Card sx={{ borderRadius: 2, p: 1, mt: 1 ,boxShadow: ' rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;'}}>
                <CardContent>
                  <Typography
                    variant="subtitle2"
                    color="primary"
                    fontWeight={600}
                    mb={1}
                  >
                    Bulk Upload Goals
                  </Typography>

                  <BulkUploadForm />

                  <Divider sx={{ my: 2 }} />

                  <Stack spacing={1} mb={2}>
                    <Button
                      size="small"
                      onClick={() => setviewTags((prev) => !prev)}
                      endIcon={
                        <Icon
                          width={20}
                          height={20}
                          icon={
                            viewTags
                              ? 'flowbite:caret-up-solid'
                              : 'flowbite:caret-down-solid'
                          }
                        />
                      }
                      variant="outlined"
                      color="primary"
                    >
                      {viewTags ? 'Hide Quarters' : 'View Quarters'}
                    </Button>

                    {viewTags && (
                      <Box
                        sx={{
                          maxHeight: 150,
                          overflowY: 'auto',
                          border: '1px solid #e0e0e0',
                          borderRadius: 1,
                          p: 1.5,
                          bgcolor: '#fafafa',
                        }}
                      >
                        <Stack
                          direction="row"
                          flexWrap="wrap"
                          gap={1}
                          justifyContent="flex-start"
                        >
                          {tagNames?.map((tags) => (
                            <Chip
                              key={tags.appraisal_tag_id}
                              size="small"
                              color="secondary"
                              label={tags.appraisal_tag_name}
                            />
                          ))}
                        </Stack>
                      </Box>
                    )}
                  </Stack>

                  <Divider sx={{ my: 2 }} />

                  <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={2}
                    alignItems="center"
                  >
                    <Button
                      size="small"
                      color="primary"
                      sx={{ width: { xs: '100%', sm: '320px' } }}
                      variant="outlined"
                      disabled={
                        profile?.departmentName !== 'Learning and Development'
                      }
                      onClick={downloadSampleExcel}
                      startIcon={
                        <Icon
                          icon="vscode-icons:file-type-excel2"
                          width="22"
                          height="22"
                        />
                      }
                    >
                      Download Admin Template
                    </Button>

                    <Button
                      size="small"
                      color="primary"
                      sx={{ width: { xs: '100%', sm: '320px' } }}
                      variant="outlined"
                      onClick={downloadSampleExcelUser}
                      startIcon={
                        <Icon
                          icon="vscode-icons:file-type-excel2"
                          width="22"
                          height="22"
                        />
                      }
                    >
                      Download User Template
                    </Button>
                  </Stack>
                </CardContent>
              </Card>
            )}
          </Grid>
        </Grid>
      </Box>
    </GlobalWrapper>
  );
};

export default AddGoals;
